const breadCrumb = "Diário Digital";

const routes = [
  {
    path: "/autorizacao-outro-servidor",
    name: "autorizacao-outro-servidor",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/AutorizacaoOutroServidor/AutorizacaoOutroServidorHome.vue"
      ),
  },
  {
    path: "/autorizacao-outro-servidor-cadastro",
    name: "autorizacao-outro-servidor-cadastro",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/AutorizacaoOutroServidor/AutorizacaoOutroServidorCad.vue"
      ),
  },
  {
    path: "/autorizacao-outro-servidor-editar/:id",
    name: "autorizacao-outro-servidor-editar",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/AutorizacaoOutroServidor/AutorizacaoOutroServidorEdit.vue"
      ),
  },
];

export default routes;
